<dialog #pdfDialog (cancel)="handleClose()">
  <div class="dialog-header">
    <div class="dialog-title">Report Preview</div>
  </div>

  <div class="dialog-body pdf-preview-body">
    @if (pdfUrl()) {
      <iframe #pdfFrame [src]="safePdfUrl()" width="100%" height="100%"></iframe>
    } @else {
      <div class="loading-state">Loading PDF...</div>
    }
  </div>

  <div class="dialog-footer">
    <button type="button" class="btn" (click)="handleClose()">Close</button>
    <button type="button" class="btn btn-primary" (click)="print()">
      <fa-icon [icon]="printIcon"></fa-icon>
      Print
    </button>
    <button type="button" class="btn btn-primary" (click)="download()">
      <fa-icon [icon]="downloadIcon"></fa-icon>
      Download
    </button>
  </div>
</dialog>
